import { Flex } from 'antd'
// import { Image } from 'react-bootstrap'
import banner from '@/assets/img/solution-banner.png'
import Styles from './style.module.scss'

export default function Index() {
  return (
    <Flex
      vertical
      align='center'
      justify='center'
      className={Styles.wrapper}
      style={{ backgroundImage: `url(${banner})` }}
    >
      <h1 className={Styles.title}>Let's Go Solar,Empower the Change,Together</h1>
    </Flex>
  )
}
